@if (view$ | async; as view) {
    <div class="d-flex justify-content-between">
        <p class="form-label">
            {{ 'monitoring_I_want_to_investigate_if' | translate }}
        </p>

        <app-tooltip
            [popover]="'consumption-agents_create_investigation_description' | translate" />
    </div>

    <div [formGroup]="view.formGroup">
        @for (investigation of view.consumptionAgentTypeInvestigations; track investigation.key) {
            @if (
                !investigation.requiredconsumptionToMonitor ||
                view.consumptionToMonitor === investigation.requiredconsumptionToMonitor
            ) {
                <div class="d-flex justify-content-between">
                    <div class="form-check ms-3">
                        <input
                            type="radio"
                            class="form-check-input"
                            formControlName="agentType"
                            [id]="investigation.key"
                            [value]="investigation.key" />
                        <label class="form-check-label" [for]="investigation.key">
                            {{ investigation.labelKey | translate }}
                        </label>
                    </div>

                    @if (investigation.descriptionKey) {
                        <app-tooltip [popover]="investigation.descriptionKey | translate" />
                    }
                </div>
            }

            @if (view.formGroup.value.agentType === investigation.key) {
                <div class="{{ investigation.class }}">
                    @for (column of investigation.columns; track $index) {
                        <div class="{{ column.class }}">
                            @for (input of column.inputs; track $index) {
                                @switch (input.type) {
                                    @case ('radio') {
                                        <div class="{{ input.class }}">
                                            <input
                                                type="radio"
                                                class="form-check-input"
                                                [id]="input.key"
                                                [value]="input.key"
                                                [formControlName]="input.formControlName" />
                                            <label class="form-check-label" [for]="input.key">
                                                {{ input.labelKey | translate }}
                                            </label>
                                        </div>
                                    }
                                    @case ('number') {
                                        <div class="{{ input.class }}">
                                            <app-input-number-group
                                                [label]="input.labelKey | translate"
                                                [descriptor]="getDescriptorValue(input.descriptor)"
                                                [information]="
                                                    input.descriptionKey &&
                                                    (input.descriptionKey | translate)
                                                "
                                                [formControlName]="input.formControlName" />
                                        </div>
                                    }
                                }
                            }
                        </div>
                    }

                    @if (investigation.subInputGroup) {
                        @if (investigation.subInputGroup.headerKey) {
                            <p class="form-label">
                                {{ investigation.subInputGroup.headerKey | translate }}
                            </p>
                        }

                        <div class="{{ investigation.subInputGroup.class }} }}">
                            @for (input of investigation.subInputGroup.inputs; track input.key) {
                                <div class="form-check">
                                    <input
                                        type="radio"
                                        class="form-check-input"
                                        [id]="input.key"
                                        [value]="input.key"
                                        [formControlName]="input.formControlName" />
                                    <label class="form-check-label" [for]="input.key">
                                        {{ input.labelKey | translate }}
                                    </label>
                                </div>
                            }
                        </div>
                    }
                </div>
            }
        }
    </div>
}
